module.exports = __webpack_public_path__ + "img/st_miniapp_code.48bff6ff.png";